'use strict';

angular.module('app.addNewTranslation', [])
    .controller('addNewTranslationCtrl', ['$scope', '$rootScope', '$modal', '$http', 'addNewTranslationService', '$modalInstance', 'mentionManagementService',
        function ($scope, $rootScope, $modal, $http, addNewTranslationService, $modalInstance, mentionManagementService) {
            $scope.translatedLanguages = [];
		    $scope.newLanguageId = 0;
		    var exist = false;
		    
		    $scope.cancel = function () {
		        $modalInstance.dismiss('cancel');
		    };

		    mentionManagementService.getLanguagesOfInterestingCountries(false)
                .then(function(response) {
                    angular.forEach(response.data, function(item) {    
		                item.ticked = false;  
		                exist = false;                           
		                if($scope.currentTranslation != null || $scope.currentTranslation != undefined) {
		                    angular.forEach($scope.currentTranslation, function(currentTranslate) {                
		                        if(currentTranslate == item.id) {
		                            exist = true;
		                        }                                       
		                    })
		                }       
		                if($scope.mention_language_id == item.id) {
		                    exist = true;
		                }                                       

		                if(!exist) {
		                    $scope.translatedLanguages.push(item);
		                }
		            })  
                }, function(errResponse) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = errResponse.message;
                })

		    $scope.addNewTranslatedLanguage = function(){
		        if($scope.translatedMention == undefined || $scope.translatedMention == null || $scope.translatedMention == ""){
		            var errorModalInstance = $modal.open({
		                scope: $scope,
		                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                windowClass: 'modal-dialog-mention-error'
		            });
		            $scope.errorModalInstance = errorModalInstance;
		            $scope.errorMessage = "Please enter Translated Mention Name";
		        }
		        
		        $scope.newLanguageId = "";
		        $scope.translatedLanguages.forEach(function(lang){
		            if(lang.ticked == true){
		                $scope.newLanguageId = lang.id;
		            }
		        })
		        if($scope.newLanguageId == 0 || $scope.currentTranslation.indexOf($scope.newLanguageId) >= 0){
		            var errorModalInstance = $modal.open({
		                scope: $scope,
		                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                windowClass: 'modal-dialog-mention-error'
		            });
		            $scope.errorModalInstance = errorModalInstance;
		            $scope.errorMessage = "Please select New Language for New Translated Mention";
		        }

		        var postData = {
		            keywordId: $scope.mention_id,
		            keywordName: $scope.translatedMention,
		            languageId: $scope.newLanguageId
		        }        
		        var checkTranslatedKeywordUrl = $rootScope.apiUrl + "mention/checkTranslatedKeywordExist";
		        if($scope.translatedMention != null && $scope.translatedMention != "" && $scope.newLanguageId != 0 && $scope.currentTranslation.indexOf($scope.newLanguageId) < 0){
		            $http.post(checkTranslatedKeywordUrl, postData)
		            .success( function (data){          
		                var newLanguage = [];
		                var getNewLanguage_url = $rootScope.apiUrl + 'mention/getLanguageById/' + $scope.newLanguageId;
		                $http.get(getNewLanguage_url, {loader: false})
		                    .success(function(responseGetNewLanguage){
		                        newLanguage.push(responseGetNewLanguage.data);
		                        var newMention = {
		                            id: 0,
		                            keyword: $scope.translatedMention,
		                            languages: newLanguage
		                        }
		                        $modalInstance.close({
		                            newMention: newMention
		                        });
		                })            
		            }).error(function (response) {
		                var errorModalInstance = $modal.open({
		                        scope: $scope,
		                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
		                        windowClass: 'modal-dialog-mention-error'
		                    });
		                    $scope.errorModalInstance = errorModalInstance;
		                    $scope.errorMessage = response.message;
		            });
		        }        
		    }
        }  
])